import React from 'react'

import { CheckoutProvider, CheckoutConsumer } from 'contexts/Checkout'
import MetaTags from 'components/MetaTags'
import { NativeAuthProvider } from 'components/NativeAuth'
import { EngravingContextProvider } from 'components/buy/Engraving/EngravingContext'

const Providers = ({ children }) => {
  return (
    <>
      <MetaTags />
      <CheckoutProvider>
        <CheckoutConsumer>
          {({ checkout, setAuthSdk, setCheckoutUser }) => (
            <NativeAuthProvider checkout={checkout} setAuthSdk={setAuthSdk} setCheckoutUser={setCheckoutUser}>
              <EngravingContextProvider>{children}</EngravingContextProvider>
            </NativeAuthProvider>
          )}
        </CheckoutConsumer>
      </CheckoutProvider>
    </>
  )
}

export default Providers
